export enum ErrorChanel {
  QA = 'qa',
  CONTENT = 'content'
}

export class BaseError extends Error {
  // @ts-ignore
  chanel: ErrorChanel;
  // @ts-ignore
  type: string;
  // @ts-ignore
  name: string;
}
